// 首页静态展示数据（临时占位，接入真实内容源后可整体替换）

export const updateTickerItems = [
  "本期新增《深夜档案·上》合集，已按时间线拼好",
  "《三年一瞬》解说字幕版已同步，逐段口播不上头",
  "《都市夜话》浓缩版上线，12 分钟看完主干",
  "混剪《同一夜》补上第二段，衔接更顺了",
  "《镜头之外》字幕校对完成，错字已修",
  "浓缩速看新增 4 条，通勤一趟正好刷完",
  "《旧事重提》合集入口已置顶到本期目录",
  "字幕版支持按段跳，找哪一段不用再拖进度条",
];

export const heroInfo = {
  issue: "第 047 期",
  date: "2026 · 09 · 12",
  kicker: "本期主题",
  title: "把散落各处的合集，按一条时间线讲完",
  lead: "合集、混剪、解说、字幕版、浓缩版，这一期都归到一处。先看梗概估个时长，再决定要不要把原片从头追一遍。",
  primaryCta: "进入本期合集入口",
  secondaryCta: "只看浓缩速看",
  stats: [
    { label: "本期条目", value: "26" },
    { label: "合计时长", value: "5h 40m" },
    { label: "更新于", value: "今日 08:20" },
  ],
};

export const contentsItems = [
  {
    no: "01",
    title: "深夜档案 · 上（合集）",
    summary: "从最初的 3 分钟片段开始铺，一直讲到事件收尾。已按时间线拼好，不用来回翻原片找顺序。",
    format: "合集",
    duration: "48 分钟",
  },
  {
    no: "02",
    title: "三年一瞬 · 解说字幕版",
    summary: "口径统一，重点段落加了字幕，口播到关键处会慢半拍，跟得上不用暂停回放。",
    format: "解说 / 字幕",
    duration: "22 分钟",
  },
  {
    no: "03",
    title: "都市夜话 · 浓缩速看",
    summary: "只留主干和转折点，把来回绕的铺垫砍掉，通勤一趟正好刷完。",
    format: "浓缩",
    duration: "12 分钟",
  },
  {
    no: "04",
    title: "同一夜 · 混剪（第二段）",
    summary: "把几个视角的画面按同一时间轴对齐，同一分钟发生了什么，一眼能对上。",
    format: "混剪",
    duration: "09 分钟",
  },
  {
    no: "05",
    title: "镜头之外 · 字幕精校版",
    summary: "上一版有几处时间标错，这次重新校对过，按段跳转已经对齐到正确位置。",
    format: "字幕",
    duration: "31 分钟",
  },
];

export const commentaryItems = [
  {
    title: "《三年一瞬》解说字幕版",
    summary: "叙述节奏放慢，遇到人名和地点会先交代背景，第一次看也不容易绕晕。",
    duration: "22 分钟",
    tag: "字幕精校",
  },
  {
    title: "《旧事重提》解说加长版",
    summary: "在原版基础上补了前后两段前情，把为什么会有这一段先讲清楚。",
    duration: "35 分钟",
    tag: "含前情",
  },
  {
    title: "《夜行记录》口播精简版",
    summary: "把重复的口播剪掉，只留判断和结论，适合已经看过原片的人复盘。",
    duration: "18 分钟",
    tag: "复盘向",
  },
  {
    title: "《一墙之隔》双语字幕版",
    summary: "中英对照字幕，专有名词统一译法，遇到方言段落另有小字标注。",
    duration: "27 分钟",
    tag: "双语",
  },
];

export const condensedItems = [
  {
    title: "《都市夜话》浓缩速看",
    summary: "12 分钟走完全程，只保留转折、结果和一句收尾，不铺垫。",
    duration: "12 分钟",
    tag: "通勤可刷",
  },
  {
    title: "《深夜档案》浓缩速看",
    summary: "把上下两集压成一条线，时间点按小时排，中途不用来回对照。",
    duration: "15 分钟",
    tag: "两集合一",
  },
  {
    title: "《同一夜》浓缩速看",
    summary: "只讲关键十分钟，其余用画面带过，看完就知道要不要看完整混剪。",
    duration: "08 分钟",
    tag: "试看",
  },
  {
    title: "《镜头之外》浓缩速看",
    summary: "挑出被讨论最多的三段单独成篇，前后逻辑仍然连得上。",
    duration: "10 分钟",
    tag: "片段精选",
  },
];

export const mashupItems = [
  {
    title: "同一夜 · 多视角混剪",
    summary: "几个镜头放在同一条时间轴上，同一分钟发生了什么，直接对齐着看。",
    duration: "09 分钟",
    tag: "时间轴对齐",
  },
  {
    title: "一年之约 · 时间线混剪",
    summary: "把同一件事在不同时间点的画面串起来，看变化发生在哪几个月。",
    duration: "14 分钟",
    tag: "跨时间",
  },
  {
    title: "碎镜头 · 混剪合辑",
    summary: "散在各处的小片段按主题归到一起，没什么顺序，随手点一段就能看。",
    duration: "11 分钟",
    tag: "碎片向",
  },
];

export const entryItems = [
  {
    title: "本期合集总入口",
    summary: "26 条一次看全，按期号排好，进来就知道这期收了什么。",
    action: "进入合集入口",
    note: "更新最勤",
  },
  {
    title: "解说字幕版专区",
    summary: "带字幕、带口播的版本都在这边，跟不上的段落可以直接慢放。",
    action: "前往字幕版",
    note: "适合第一次看",
  },
  {
    title: "浓缩版打包入口",
    summary: "把每期的浓缩速看汇到一处，碎片时间随手点一段就不会断。",
    action: "打开浓缩入口",
    note: "省时间",
  },
];

export const faqItems = [
  {
    q: "合集和混剪到底有什么区别？",
    a: "合集的顺序按事件发生的时间线来，前后能连成一条线；混剪是把多个视角或不同时间的画面放到同一条时间轴上对照，适合看同一分钟里各处的差别。",
  },
  {
    q: "解说字幕版和原片差别大吗？",
    a: "画面基本沿用原片，差别在于叙述节奏和字幕。遇到人名、地点会先交代背景，关键段落放慢，第一次看不容易绕晕。",
  },
  {
    q: "浓缩版值得单独看一遍吗？",
    a: "如果只想快速知道经过和结果，看浓缩版就够。它会砍掉铺垫，只留转折和结论，通常八到十五分钟。",
  },
  {
    q: "条目这么多，怎么决定先看哪条？",
    a: "先看每条下面的短摘要估个时长和角度，再挑今天有时间的。本期目录里标了时长，浓缩版都控制在十五分钟以内。",
  },
  {
    q: "更新大概是什么频率？",
    a: "合集和字幕版跟着整理进度走，浓缩速看通常同步上线。首页顶部的更新条会按时间列出最近新增的条目。",
  },
];